// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundInvoiceBreakdownRecordDto
 */
export interface IPrefundInvoiceBreakdownRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    invoice_close_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    plan_calced?: string;
    /**
     * 
     * @type {number}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    plan_enrollment?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    plan_percent?: string;
    /**
     * 
     * @type {number}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    prefund_for_plan?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    using_minimum?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    employee_plan?: string;
    /**
     * 
     * @type {number}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    policy_election_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IPrefundInvoiceBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IPrefundInvoiceBreakdownRecordDto interface.
 */
export function instanceOfIPrefundInvoiceBreakdownRecordDto(value: object): value is IPrefundInvoiceBreakdownRecordDto {
    return true;
}

export function IPrefundInvoiceBreakdownRecordDtoFromJSON(json: any): IPrefundInvoiceBreakdownRecordDto {
    return IPrefundInvoiceBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IPrefundInvoiceBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundInvoiceBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_close_date': json['invoice_close_date'] == null ? undefined : (new Date(json['invoice_close_date'])),
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_calced': json['plan_calced'] == null ? undefined : json['plan_calced'],
        'plan_enrollment': json['plan_enrollment'] == null ? undefined : json['plan_enrollment'],
        'plan_percent': json['plan_percent'] == null ? undefined : json['plan_percent'],
        'prefund_for_plan': json['prefund_for_plan'] == null ? undefined : json['prefund_for_plan'],
        'using_minimum': json['using_minimum'] == null ? undefined : json['using_minimum'],
        'employee_plan': json['employee_plan'] == null ? undefined : json['employee_plan'],
        'policy_election_amount': json['policy_election_amount'] == null ? undefined : json['policy_election_amount'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IPrefundInvoiceBreakdownRecordDtoToJSON(json: any): IPrefundInvoiceBreakdownRecordDto {
    return IPrefundInvoiceBreakdownRecordDtoToJSONTyped(json, false);
}

export function IPrefundInvoiceBreakdownRecordDtoToJSONTyped(value?: IPrefundInvoiceBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_close_date': value['invoice_close_date'] == null ? undefined : ((value['invoice_close_date']).toISOString().substring(0,10)),
        'plan_id': value['plan_id'],
        'plan_calced': value['plan_calced'],
        'plan_enrollment': value['plan_enrollment'],
        'plan_percent': value['plan_percent'],
        'prefund_for_plan': value['prefund_for_plan'],
        'using_minimum': value['using_minimum'],
        'employee_plan': value['employee_plan'],
        'policy_election_amount': value['policy_election_amount'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

